import { ResetFieldsArgs } from './resetFields.types';

export const resetFields = <T extends any>({
  form,
  values,
}: ResetFieldsArgs<T>) =>
  values.map(({ name, value = undefined }) => form.change(name, value));
